var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"WLink",class:[_vm.iconPlacement, _vm.color],attrs:{"href":"#","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.disabled ? undefined : _vm.$emit('click', $event)}}},[(_vm.icon)?_c('WIcon',{class:_vm.iconPlacement,attrs:{"icon":_vm.icon,"size":14}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }